import {
  applyVspProjectInWellsApi,
  getActiveVspOffsetForProjectWellsApi,
  importVspFilesApi,
  setActiveProjectVspApi,
  updateOffsetByProjectVspApi,
} from '@core/core/api'
import type { FieldId, ProjectVsp, ProjectVspId, VspData } from '@core/core/types'
import { addVspAppliedNotification, addVSPErrorNotification } from '@notifications/actions'
import messenger from 'common/messenger'
import type { ProjectId, WellId } from 'common/types'

import type { AppThunk } from '../store'
import { vspSlice } from './vspSlice'

const { updateOffsetVsp, activateVsp, addWellsVspToProject } = vspSlice.actions

export const importVspFile =
  (
    projectId: ProjectId,
    wellId: WellId,
    isNegativeZ: boolean,
    isNegativeTwt: boolean,
    file: File,
  ): AppThunk =>
  () => {
    importVspFilesApi(projectId, wellId, isNegativeZ, isNegativeTwt, file)
      .then(() => {
        notifyVspChanged([wellId])
      })
      .catch((err: unknown) => {
        addVSPErrorNotification(err)
      })
  }

export const getWellsVspForProject =
  (projectId: ProjectId, fieldId: FieldId): AppThunk =>
  dispatch => {
    getActiveVspOffsetForProjectWellsApi(projectId, fieldId)
      .then(wells => dispatch(addWellsVspToProject(wells)))
      .catch(console.error)
  }

export const updateOffsetByProjectVsp =
  (
    projectVspId: ProjectVspId,
    wellId: WellId,
    projectId: ProjectId,
    offset: ProjectVsp['offset'],
  ): AppThunk =>
  dispatch => {
    updateOffsetByProjectVspApi(projectVspId, projectId, { offset: Number(offset) })
      .then(() => {
        notifyVspChanged([wellId])
        dispatch(updateOffsetVsp({ wellId, vspId: projectVspId, offset }))
      })
      .catch(console.error)
  }

export const setActiveProjectVsp =
  (projectId: ProjectId, wellId: WellId, vspId: ProjectVsp['vspId']): AppThunk =>
  dispatch => {
    setActiveProjectVspApi(projectId, wellId, vspId)
      .then(() => {
        notifyVspChanged([wellId])
        dispatch(activateVsp({ wellId, vspId }))
      })
      .catch(console.error)
  }

export const applyVspProjectInWells =
  (projectId: ProjectId, data: VspData, fieldId: FieldId, vspName: string): AppThunk =>
  dispatch => {
    applyVspProjectInWellsApi(projectId, data)
      .then(() => {
        notifyVspChanged(data.wellIds)
        dispatch(getWellsVspForProject(projectId, fieldId))
        addVspAppliedNotification(vspName)
      })
      .catch(console.error)
  }

const notifyVspChanged = (wellIds: WellId[]) => {
  messenger.send({ type: 'vspChanged', payload: wellIds })
}
